import { useAuth } from '../Components/Auth/AuthProvider';

const buildHttpError = async response => {
  let responseText = '';
  try {
    responseText = await response.text();
  } catch {
    responseText = '';
  }

  const error = new Error(`HTTP error! status: ${response.status}`);
  error.name = 'ApiHttpError';
  error.status = response.status;
  error.responseText = responseText;
  return error;
};

const buildNetworkError = error => {
  const networkError = new Error(
    'Network/CORS error: Request could not reach API or response was blocked by browser CORS policy.'
  );
  networkError.name = 'ApiNetworkError';
  networkError.cause = error;
  return networkError;
};

export const useApiFetch = () => {
  const { acquireToken } = useAuth();

  const getHeaders = async (forceRefresh = false) => {
    const token = await acquireToken(forceRefresh);
    if (!token) {
      throw new Error('Failed to acquire authentication token');
    }
    return {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    };
  };

  const fetchData = async (url, method = 'GET', body = null, retry = true) => {
    try {
      const headers = await getHeaders();
      const options = {
        method,
        headers
      };
      if (body) {
        options.body = JSON.stringify(body);
      }

      let res;
      try {
        res = await fetch(url, options);
      } catch (networkFailure) {
        throw buildNetworkError(networkFailure);
      }

      if (res.status === 401 && retry) {
        console.log('Token expired (401), refreshing and retrying...');
        // Force refresh
        const newHeaders = await getHeaders(true);
        options.headers = newHeaders;
        let retryRes;
        try {
          retryRes = await fetch(url, options);
        } catch (networkFailure) {
          throw buildNetworkError(networkFailure);
        }
        if (!retryRes.ok) {
          throw await buildHttpError(retryRes);
        }
        return retryRes.json();
      }

      if (!res.ok) {
        throw await buildHttpError(res);
      }
      return res.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  };

  return fetchData;
};
